import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router'; 

@Component({
    selector: 'app-case-studies-details-page',
    templateUrl: './case-studies-details-page.component.html',
    styleUrls: ['./case-studies-details-page.component.scss']
})
export class CaseStudiesDetailsPageComponent2 implements OnInit {

    constructor(private router: Router) { }

    ngOnInit(): void {
        this.router.events.subscribe((event) => { 
            if (!(event instanceof NavigationEnd)) { 
                return; 
            } 
            window.scrollTo(0, 0) 
        }); 
    }

    pageTitleArea: pageTitle[] = [
        {
            title: 'Case Study: Reducing Crowding in Common Areas at a Hospital',
            subTitle: '1',
        }
    ]

    caseStudiesDetailsDesc: DetailsDesc[] = [
        {
            subTitle: 'Surveillance, Public Safety, Compliance',
            img1: '',
            title1: 'Company Overview',
            paragraph1: 'Aarvy Hospitals is a prominent chain of six hospitals located across Delhi NCR. Known for its quality healthcare services, Aarvy Hospitals faced significant challenges in managing the flow of people in common areas during the COVID-19 pandemic. Ensuring social distancing and controlling crowd density became critical to reduce the spread of infections.',
            title2: 'Problem Statement',
            paragraph2: 'Aarvy Hospitals needed to control the number of people in common areas such as waiting rooms, lobbies, and cafeterias to maintain social distancing and reduce the risk of spreading COVID-19 and other infections. Manual monitoring was insufficient and prone to errors, leading to frequent overcrowding. Objective is to implement an AI-powered computer vision system to monitor and control crowd density, ensuring minimum distance is maintained between individuals and alerting staff if specified limits are exceeded.',
            title3: 'Solution',
            paragraph3: 'Aarvy Hospitals partnered with Awareye in late 2022 to deploy an advanced camera system capable of real-time crowd monitoring and density control using AI-driven computer vision technology.',
            title4: 'Implementation',
            title5: 'Results',
            title6: "Conclusion",
            paragraph6: 'The implementation of Awareye’s computer vision system across Aarvy Hospitals successfully controlled the number of people in common areas and ensured social distancing. This technological advancement played a crucial role in reducing the spread of infections, enhancing patient and staff safety, and improving operational efficiency. The success of this project highlights the potential of AI-driven solutions in addressing public health challenges in healthcare settings.',
        }
    ]
    ImplementationDetails: BulletPointDetails[] = [
        {
            title: 'System Design and Integration',
            details: [
                'Cameras: Wide-angle, night-vision cameras were strategically placed in common areas of each hospital to cover all entry points and gathering spots.',
                'AI Model Training: Awareye developed and trained models to detect and count individuals, measure distances between them, and identify crowd build-ups.',
                'OTA Updates: The AI system was set up to receive Over-the-Air (OTA) updates, ensuring the algorithms remained up-to-date with the latest advancements without needing hardware changes.'
            ]
        },
        {
            title: 'Monitoring Process',
            details: [
                'Real-Time Tracking: Cameras continuously captured video feeds of common areas. The AI model processed these feeds to count people and measure distances between them.',
                'Distance Verification: The AI system ensured that individuals maintained a minimum distance as per health guidelines. If the distance was breached, an alert was triggered to alert the hospital staff to take required action.',
                'Crowd Density Control: The system monitored the number of people in each area. When the count approached the specified limit, alerts were sent to hospital staff for intervention.'
            ]
        },
        {
            title: 'Alerting and Reporting',
            details: [
                'Real-Time Alerts: Alerts were sent to hospital staff via a dedicated mobile app and dashboard, enabling prompt action to disperse crowds or redirect people to less crowded areas.',
                'Analytics and Reporting: The system generated reports on crowd density trends, helping the hospital management to understand peak times and optimize the flow of people.'
            ]
        }
    ]
    ResultDetails: BulletPointDetails[] = [
        {
            title: 'Improved Crowd Control',
            details: [
                'Overcrowding incidents in common areas reduced by 85%.',
                'Compliance with social distancing guidelines improved significantly.'
            ]
        },
        {
            title: 'Enhanced Safety',
            details: [
                'The risk of COVID-19 and other infections spreading in the hospital was minimized.',
                'Patient and staff safety increased, leading to greater confidence in hospital safety measures.'
            ]
        },
        {
            title: 'Operational Efficiency',
            details: [
                'Real-time alerts allowed for quick action to manage crowd density.',
                'The automated system reduced the need for manual monitoring, allowing staff to focus on patient care.'
            ]
        }
    ]
    caseStudiesDetailsInfo: Info[] = [
        {
            icon: 'bx bx-user-pin',
            title: 'Client',
            subTitle: 'Aarvy Hospital',
        },
        {
            icon: 'bx bx-globe',
            title: 'Website',
            subTitle: 'https://aarvyhealthcare.com',
        },
        {
            icon: 'bx bx-map',
            title: 'Location',
            subTitle: 'Sector 90, Gurugram, Haryana 122505, India',
        },
        {
            icon: 'bx bx-purchase-tag',
            title: 'Industry',
            subTitle: 'HealtCare',
        },
        {
            icon: 'bx bx-check',
            title: 'Completed',
            subTitle: 'March 2024',
        }
    ]

}
class pageTitle {
    title : string;
    subTitle : string;
}
class DetailsDesc {
    subTitle : string;
    title1 : string;
    title2 : string;
    title3 : string;
    title4 : string;
    title5 : string;
    title6 : string;
    img1 : string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
    paragraph6: string;
}
class BulletPointDetails {
    title : string;
    details : string[];
}
class Info {
    icon : string;
    title : string;
    subTitle : string;
}